module.exports = require("core-js/library/fn/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./~/_@babel_runtime@7.0.0-beta.46@@babel/runtime/core-js/object/get-own-property-symbols.js
// module id = 286
// module chunks = 6